import React from "react";
import GitHubCalendar from "react-github-calendar";
import AnimatedSection from "../AnimatedSection";

function Github() {
  return (
    <AnimatedSection>
      <div className="github-section">
        <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
          Days I <span className="purple">Code</span>
        </h1>
        <div style={{ overflowX: "auto", display: "flex", justifyContent: "center" }}>
          <GitHubCalendar
            username="aaftabali1"
            blockSize={15}
            blockMargin={5}
            color="#a855f7"
            fontSize={16}
          />
        </div>
      </div>
    </AnimatedSection>
  );
}

export default Github;
